import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import TriggerPatterns from './TriggerPatterns';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchCompanyTriggerPatterns } from './companyTriggerApi';

/** Company Trigger Trace → Patterns. */
const CTriggerPatterns = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchCompanyTriggerPatterns(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Trigger Trace — Patterns | Shoorah</title>
      </Helmet>
      <TriggerPatterns fetcher={fetcher} />
    </div>
  );
};

export default CTriggerPatterns;
